import React from 'react';
import { observer } from 'src/utils/mobx-react';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import { RealexTab } from 'src/components/TopUpProcedure/RealexForm/RealexTab';
import { PaymentProvidersType } from 'src/AppState/ConfigState/types';
import { PaysafeTab } from './Paysafe/PaysafeTab';

interface PropsType {
    permissionGrants: ImmutablePropTypes.map;
    usePaymentFormForUniverse: PaymentProvidersType;
    customerId: number;
    onQueryAudits: () => void;
}

export const TopUpProcedure = observer(
    'TopUpProcedure',
    ({ permissionGrants, usePaymentFormForUniverse, customerId, onQueryAudits }: PropsType): JSX.Element => {
        if (usePaymentFormForUniverse.type === 'realex' || usePaymentFormForUniverse.type === 'multi-deposit') {
            return (
                <RealexTab
                    customerId={customerId}
                    permissionGrants={permissionGrants}
                    onQueryAudits={onQueryAudits}
                />
            );
        }
        if (usePaymentFormForUniverse.type === 'paysafe') {
            return (
                <PaysafeTab
                    customerId={customerId}
                    permissionGrants={permissionGrants}
                    paysafePaymentProviderConfig={usePaymentFormForUniverse}
                    onQueryAudits={onQueryAudits}
                />
            );
        }
        return <div data-test='deposit-support-info'>Not supported</div>;
    }
);
